import $ from 'jquery';
// import mpro from './mpro.init';
import Parsley from '../../modules/parsley.js';
import './mpro.form-actions.js';
import './mpro.form-plugins.js';

/**
 * Set or replace the current validator type message
 * @param {string|{ [key: string]: string }} validatorName
 * @param {string?} message
 */
mpro.setFormValidationMessage = Parsley.setFormCustomValidationMessage;

/**
 * Handle Form Actions (buttons, submit, errors)
 *
 * @param {JQuery} $cont
 */
mpro.handleForms = function($cont) {

	// Save config vars
	const { ui } = mpro.config;
	const rowInvalidSelector = ui.form_row_invalid_class;
	const validationSelector = ui.form_js_validation_selector;

	// Submit outline button class
	mpro.formWidgetsHandleSubmitButton($cont);

	// Handle form errors post submit
	const $errors = $cont.find(rowInvalidSelector);
	if ($errors.length > 0) {
		// Scroll to first error
		mpro.scrollToElement($errors.first()).promise().done(/** @this {HTMLElement} */ function() {
			$(this).trigger('focus');
		});
	}

	// Find parsley forms
	const $parsleyForms = $cont.find('form').filter(validationSelector);

	// Activate parsley on forms
	if ($parsleyForms.length > 0) {
		mpro.handleParsleyForms($parsleyForms);
	}
};

/**
 * Parsley form validation
 *
 * @param {JQuery<HTMLFormElement>} $parsleyForms
 */
mpro.handleParsleyForms = function($parsleyForms) {

	// Save config vars
	const { ui } = mpro.config;
	const rowSelector = ui.form_validator_container_selector;
	const rowInvalidClass = ui.form_row_invalid_class;
	const invalidFeedbackClass = ui.form_row_invalid_feedback_class;

	$parsleyForms.each(function() {
		const $this = $(this);
		const parsleyFormInstance = $this.parsley({
			inputs: 'input[name], textarea[name], select[name], input[data-parsley-validate], textarea[data-parsley-validate], select[data-parsley-validate]',
			excluded: '[disabled], input[type=button], input[type=submit], input[type=reset], input[type=hidden]:not([required]), [data-parsley-excluded="true"], :not(:visible):not([required])',
			focus: 'none',
			// trigger: 'focusout'
			trigger: null,
			// triggerAfterFailure: 'input',
			triggerAfterFailure: 'focusout change',
			// Error handling
			errorsContainer(field) {
				const fieldId = field.$element[0].id;
				if (fieldId) {
					const $existingContainer = $(`#errors_container_${fieldId}`);
					if ($existingContainer.length > 0) {
						return $existingContainer;
					}
				}
				return field.$element.closest(rowSelector);
			},
			// ul elem that would receive errors' list
			errorsWrapper: `<div class="${invalidFeedbackClass}"></div>`,
			// li elem that would receive error message
			errorTemplate: '<div></div>',
		});

		// Got the instance
		if (parsleyFormInstance) {
			// Flag with validation method
			$this.data('submit_handler', 'form-parsley-validate');

			// $.each(parsleyFormInstance.fields, function(i, v) {
			// 	this.options = $.extend(this.options || {}, {
			// 		triggerAfterFailure: 'focusout'
			// 	});
			// 	this.actualizeOptions();
			// });

			// --------------------
			// --- Add handlers ---
			// --------------------
			parsleyFormInstance
				// When field validation is starting
				.on('field:validate', (field) => {

					/** @type {JQuery} */ // @ts-ignore
					const { $element } = field;

					// Is a required simple form file input
					if ($element.is('input[type="file"]') && $element.closest('[data-file-upload]').length > 0) {

						// Look for already uploaded files that are referenced in the parent
						const $parent = $element.parent();
						if ($parent.find('input[type="hidden"][data-form-file]').length > 0) {
							// Skip validation only when the required attribute is present
							if ($element.prop('required')) {
								$element.prop('required', false);
								field.removeConstraint('required');
								$element.data('prev-required-state', true);
							}
						}
						// Previous required state was modified
						else if ($element.data('prev-required-state')) {
							$element.prop('required', true);
							field.addConstraint('required', true, undefined, true);
							$element.data('prev-required-state', null);
						}
					}
				})
				// When field validation finished
				.on('field:validated', (field) => {
					if (field.validationResult !== true) {
						field.$element.closest(rowSelector).addClass(rowInvalidClass);
					}
					else {
						field.$element.closest(rowSelector).removeClass(rowInvalidClass);
					}
				})
				// After form was validated
				// .on('form:validated', function (parsleyForm) {
				// 	parsleyForm.$element.addClass('form--validated');
				// })
				// On form errors
				.on('form:error', (parsleyForm) => {
					try {
						for (const field of parsleyForm.fields) {
							if (field.validationResult !== true) {
								let $scrollToElement = field.$element.filter(':visible');
								if ($scrollToElement.length === 0) {
									$scrollToElement = field.$element.closest(rowSelector);
								}

								if ($scrollToElement.length > 0) {
									mpro.scrollToElement($scrollToElement, { blink: true }).promise().done(() => {
										field.$element.focus();
									});
								}

								break;
							}
						}
					}
					catch (error) {
						console.warn('Cannot scroll to element in parsley error', error, parsleyForm);
					}
				})
				.on('form:submit', (parsleyForm) => {
					mpro.handleSubmitButtons(parsleyForm.$element);
				});
		}
	});
};

// Disable the submit button and add a small animation
mpro.disableSubmitButton = function($btn) {
	if (!$btn || $btn.length === 0 || $btn.data('original-element')) {
		return;
	}
	// Make a backup
	$btn.data('original-element', $btn.clone());
	// var btnStyle = $btn.css(['width', 'height']);
	// // Add a spinning animation on the submit button
	// $btn.css({ width: btnStyle.width, height: btnStyle.height }).prop('disabled', true).html($('<img/>', {
	// 	'src': PATH_STATIC + '/img/site/submit-loader.gif',
	// 	'alt': 'Loading...',
	// 	'class': 'fa fa-fw fa-refresh fa-spin',
	// 	'style': 'position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);'
	// }));
	$btn.addClass('btn-loading disabled').prop('disabled', true);
	$btn.on('click.submit_disabled', false);
};

// Restore the submit button to its initial state before applying the disable function
mpro.restoreSubmitButton = function($btn) {
	if (!$btn || $btn.length === 0) {
		return $btn;
	}
	const $origBtn = $btn.data('original-element');
	if ($origBtn && $origBtn.length > 0) {
		$origBtn.insertAfter($btn);
		$btn.remove();
		return $origBtn;
	}
	return $btn;
};

/**
 * Apply the handler to disable submit buttons where necessary
 *
 * @param {JQuery<HTMLFormElement>} $form
 */
mpro.handleSubmitButtons = function($form) {
	const $submitButtons = $form.find('button[type=submit],input[type=submit]');
	$submitButtons.each(function() {
		mpro.disableSubmitButton($(this));
	});

	const $fancyWrapper = $form.closest('.fancy-wrapper');
	if ($fancyWrapper.length > 0) {
		const $btnRemoteSubmit = $fancyWrapper.find('.fancy-footer .btn-remote-submit');
		if (!$btnRemoteSubmit.is($submitButtons)) {
			$btnRemoteSubmit.each(function() {
				mpro.disableSubmitButton($(this));
			});
		}
	}

	// Restore the button state once the browser comes back from BFCache
	mpro.oncePageRestore(() => void mpro.handleRestoreSubmitButtons($form));
};

/**
 * Apply the handler to undo submit button modifications
 *
 * @param {JQuery<HTMLFormElement>} $form
 */
mpro.handleRestoreSubmitButtons = function($form) {
	const $submitButtons = $form.find('button[type=submit],input[type=submit]');
	$submitButtons.each(function() {
		mpro.restoreSubmitButton($(this));
	});

	const $fancyWrapper = $form.closest('.fancy-wrapper');
	if ($fancyWrapper.length > 0) {
		const $btnRemoteSubmit = $fancyWrapper.find('.fancy-footer .btn-remote-submit');
		if (!$btnRemoteSubmit.is($submitButtons)) {
			$btnRemoteSubmit.each(function() {
				mpro.restoreSubmitButton($(this));
			});
		}
	}
};

/**
 * Apply the handler to undo submit button modifications
 *
 * @param {JQuery<HTMLFormElement>} $parentForm
 * @param {any} paramsSelector
 */
mpro.getFormParams = function($parentForm, paramsSelector) {
	if (paramsSelector) {
		const pt = $.type(paramsSelector);

		if (pt === 'array') {
			let a = [];
			for (let i = 0, l = paramsSelector.length; i < l; ++i) {
				const sel = paramsSelector[i];
				a = a.concat(mpro.getFormParams($parentForm, sel));
			}
			return a;
		}
		else if (pt === 'string') {
			let m;
			// eslint-disable-next-line prefer-named-capture-group
			if ((m = /^\(data=['"]?([\w\-]+)['"]?\)$/u.exec(paramsSelector))) {
				const d = m[1];
				const dObj = $parentForm.data(d);
				const t = $.type(dObj);

				if (t === 'object') {
					const a = [];
					for (const s in dObj) {
						if (Object.hasOwn(dObj, s)) {
							a.push({ name: s, value: dObj[s] });
							return a;
						}
					}
				}
				else if (t === 'array') {
					return dObj;
				}
			}
			else {
				return $parentForm.find(paramsSelector).serializeArray();
			}
		}
	}
	return $parentForm.serializeArray();
};

/**
 * @param {HTMLFormElement} parentForm
 * @param {any} paramsSelector
 */
mpro.getParentFormParams = function(parentForm, paramsSelector) {
	if (!parentForm) {
		return false;
	}

	/** @type {JQuery<HTMLFormElement>} */
	// @ts-ignore
	let $parentForm = $(parentForm);
	if ($parentForm.length === 0) {
		return false;
	}
	if (!$parentForm.is('form')) {
		// @ts-ignore
		$parentForm = $parentForm.find('form:first');
	}
	return mpro.getFormParams($parentForm, paramsSelector);
};

/**
 * @param {any[]} formParams
 * @param {JQuery<HTMLFormElement>} $actualForm
 */
mpro.applyFormParams = function(formParams, $actualForm) {
	if (formParams && formParams.length > 0) {
		for (let i = 0, l = formParams.length; i < l; ++i) {
			const sel = formParams[i];
			const $input = $('<input type="hidden" />');
			$input.attr({
				name: sel.name,
				value: sel.value,
			});
			$actualForm.append($input);
		}
		return true;
	}
	return false;
};

/**
 * Better encodeURIComponent
 *
 * @param {string} str
 * @param {boolean} forUrl
 */
mpro.encodeURIComponent = function(str, forUrl) {

	forUrl = (forUrl == null) ? true : Boolean(forUrl);

	let enc = encodeURIComponent(str)
		// Note that although RFC3986 reserves "!", RFC5987 does not,
		// so we do not need to escape it
		// i.e., %27 %28 %29
		.replaceAll(/['()]/g, escape)
		.replaceAll('*', '%2A')
		// The following are not required for percent-encoding per RFC5987,
		// so we can allow for a little better readability over the wire: |`^
		.replaceAll(/%(?:7C|60|5E)/g, unescape);

	// For application/x-www-form-urlencoded, spaces are to be replaced by +
	if (forUrl) {
		enc = enc.replaceAll('%20', '+');
	}

	return enc;
};

/**
 * Extended version of JQuery.fn.serializeArray() that also includes the form elements
 * Optionally, all values are converted to arrays
 *
 * @param {HTMLFormElement} form
 */
mpro.getFormSubmitElements = (form) => {
	const
		rcheckableType = /^(?:checkbox|radio)$/i;
	const rsubmittable = /^(?:input|select|textarea|keygen)/i;
	const rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i
		;

	return $(form).map(function() {
		// Can add propHook for "elements" to filter or add form elements
		// @ts-ignore
		const elements = $.prop(this, 'elements');
		return elements ? $.makeArray(elements) : this;
	})
		.filter(function() {
			const { type } = this;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !$(this).is(':disabled') &&
				rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) &&
				(this.checked || !rcheckableType.test(type));
		}).get();
};

/**
 * Auto-reset form elements
 *
 * @param {JQuery<HTMLElement>} $container
 */
mpro.handleFormAutoReset = ($container) => {

	/**
	 * @type {JQuery<HTMLFormElement>}
	 */
	// @ts-ignore
	const $resetElements = $container.find('form[data-auto-reset]').not('[data-auto-reset="false"],[data-auto-reset="off"],[data-auto-reset="0"]');

	for (const elem of $resetElements) {
		elem.reset();
	}
};

// Add init function that is executed on every page/fragment render
mpro.addInitStatic(($container) => {

	// Form handling
	mpro.handleForms($container);

	// Handle form actions (remotes, change handlers, etc)
	mpro.handleFormActions($container);

	// Add form plugins
	mpro.addFormPlugins($container);

	// Reset forms on bac/forward navigation
	mpro.handleFormAutoReset($container);

	// Auto trigger change on document load
	$container.find('.trigger-change').trigger('change', [{ by: 'auto-trigger-change' }]);

	// Autofocus first element in form
	$container.find('form[autofocus]').each(function() {
		$(this).find('input,textarea').filter(':visible:enabled[value=\'\']:first').not('[type=hidden]').first().trigger('focus');
	});

	// Autofocus form elements
	$container.find('input[autofocus],textarea[autofocus]').filter(':visible:enabled[value=\'\']:first').not('[type=hidden]').last().trigger('focus');
});

// Add init function that is executed only on first dom-ready (it should contain only document/body delegate handlers)
mpro.addInitDelegate(($) => {

	// Standard form submissions
	mpro.get$B().on('submit.regular_submit', 'form', function() {
		let $form = $(this);
		// Exclude specific forms
		$form = $form.not('form.form-parsley-validate, form.form-parsley, form.jform-err-parse');
		if ($form.length > 0) {
			if (!$form.data('submit_handler')) {
				mpro.handleSubmitButtons($form);
			}
		}
	});
});

export default mpro;
